import axios from 'axios'

const util = require('../../util.js')

const default_filter = {
  subscriptionContractId: null,
  subscriptionPlanId: null,
  productId: null,
  customer: null,
  owner: null,
  buyer: null,
  reference: null,
  createdFrom: null,
  createdTo: null
}

const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100],
  totalRows: 0
}

const state = {
  subscription: {
    uuid: undefined,
    cartItem: {
      uuid: undefined,
      productId: undefined,
      productName: undefined,
      amount: undefined,
      subscriptionPlan: undefined,
      subscriptionPeriod: undefined,
    },
    customerType: undefined,
    customerReferenceId: undefined,
    subscriptionContractId: undefined,
    subscriptionPlanId: undefined,
    subscriptionPeriodId: undefined,
    buyerId: undefined,
    ownerId: undefined,
    paymentSource: undefined,
    initialPrice: undefined,
    recurringPrice: undefined,
    customerNumber: undefined,
    customerOriginId: undefined,
    checkoutSessions: {
      id: undefined,
      uuid: undefined,
      vippsIdempotencyKey: undefined,
      status: undefined,
      paymentSource: undefined,
      cart: {
        id: undefined,
        uuid: undefined,
        status: undefined,
        userId: undefined,
        productSource: undefined,
        customerNumber: undefined,
        customerOriginId: undefined,
        // etc
      }
      // etc
    },
    startAt: undefined,
    renewAt: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  },
  subscriptions: [],
  filter: { ...default_filter },
  paging: { ...default_paging },
}

const mutations = {
  UPDATE_SUBSCRIPTION (state, payload) {
    state.subscription = payload
  },
  UPDATE_SUBSCRIPTIONS (state, payload) {
    state.subscriptions = payload.response
    state.paging.totalRows = payload.resultCount
  },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
  },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
  },
}

const actions = {
  async getSubscriptions ({ commit, dispatch }) {
    await dispatch('getSelectedActiveProfile')
    return axios.get(process.env.VUE_APP_COMMERCE_API_BASEURL + '/admin/subscriptions', {
      params: {
        subscriptionContractId: util.emptyToNull(state.filter.subscriptionContractId),
        subscriptionPlanId: util.emptyToNull(state.filter.subscriptionPlanId),
        productId: util.emptyToNull(state.filter.productId),
        customer: util.emptyToNull(state.filter.customer),
        owner: util.emptyToNull(state.filter.owner),
        buyer: util.emptyToNull(state.filter.buyer),
        reference: util.emptyToNull(state.filter.reference),
        createdFrom: util.dateToTimestamp(state.filter.createdFrom),
        createdTo: util.dateToTimestamp(state.filter.createdTo),
        pageNumber: util.emptyToNull(state.paging.currentPage),
        pageSize: util.emptyToNull(state.paging.perPage)
      }
    }).then((response) => {
      commit('UPDATE_SUBSCRIPTIONS', response.data)
    })
  },
  getSubscription ({ commit }, uuid) {
    return axios
      .get(process.env.VUE_APP_COMMERCE_API_BASEURL + '/admin/subscriptions/' + uuid)
      .then((response) => {
        commit('UPDATE_SUBSCRIPTION', response.data)
      })
  },
  postSubscription ({ commit }, uuid) {
    return axios
      .post(process.env.VUE_APP_COMMERCE_API_BASEURL + '/admin/subscriptions/' + uuid)
  },
  deleteSubscription ({ commit }, uuid) {
    return axios
      .delete(process.env.VUE_APP_COMMERCE_API_BASEURL + '/admin/subscriptions/' + uuid)
  },
  cancelSubscription ({ commit }, uuid) {
    return axios
      .post(process.env.VUE_APP_COMMERCE_API_BASEURL + '/admin/subscriptions/' + uuid + '/cancel')
  },
  resetFilter ({ commit }) {
    commit('UPDATE_PAGING', { ...default_paging })
    commit('UPDATE_FILTER', { ...default_filter })
  },
  getSelectedActiveProfile ({ commit, rootGetters }) {
    let isActiveProfileSelected = rootGetters['sessionStorage/isActiveProfileSet']
    if(isActiveProfileSelected) {
      let activeProfile = rootGetters['sessionStorage/activeProfile']
      if(activeProfile != null) {
        commit('UPDATE_ORGANIZATION_NUMBER', activeProfile.id)
      }
    }
  }
}

const getters = {
  subscription: state => state.subscription,
  subscriptions: state => state.subscriptions,
  filter: state => state.filter,
  paging: state => state.paging,
}

const subscriptionsModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default subscriptionsModule
